<template>
  <div class="qestjxflzs text_center">
    <div class="between">
      <sec-title
        Text="法律知识科普"
		:showmore = 'false'
      />
	  <div class="tag between">
	    <div class="tag_list flex_start">
	      <div :class="{ atg_activ: tagactive == 0 }" @click="tagcl(0)">
	        视频普法
	      </div>
	      <div :class="{ atg_activ: tagactive == 1 }" @click="tagcl(1)">
	        法律音频
	      </div>
	      <div :class="{ atg_activ: tagactive == 2 }" @click="tagcl(2)">
	        律师文集
	      </div>
	    </div>
	    <div class="mo">更多></div>
	  </div>
    </div>
    <el-carousel v-show="tagactive == 0" ref="swiperll" indicator-position="none" arrow='never' :loop='false' :autoplay = 'false' height='400px'>
       <el-carousel-item v-for="item in 3" :key="item">
         
    				<div class="cont between wrap" >
    				  <div class="cont_i" v-for="(item, index) in 3" :key="index">
    				    <ques-media class="cont_imedia" type="video" :src="imgsrc" />
    				    <div class="desctext">
    				      <div class="title3 ellipsis">摩托无证醉驾判刑多久</div>
    				      <div class="time_num flex_start">
    				        <div class="center">
    				          <svg-icon icon-class="time" class="svgimg" />
    				          2021-03-12
    				        </div>
    				        <div class="center">
    				          <svg-icon icon-class="linear-play" class="svgimg" />
    				          775人收看
    				        </div>
    				      </div>
    				    </div>
    				  </div>
    				</div>
    				
       </el-carousel-item>
     </el-carousel>

    
	<el-carousel v-show="tagactive == 1" ref="swiperll1" indicator-position="none" arrow='never' :loop='false' :autoplay = 'false' height='400px'>
	   <el-carousel-item v-for="item in 3" :key="item">
	     
					<div class="cont between wrap" >
					  <div class="cont_i" v-for="(item, index) in 3" :key="index">
					    <ques-media class="cont_imedia" type="audio" :src="imgsrc" />
					    <div class="desctext">
					      <div class="title3 ellipsis">摩托无证醉驾判刑多久</div>
					      <div class="time_num flex_start">
					        <div class="center">
					          <svg-icon icon-class="time" class="svgimg" />
					          2021-03-12
					        </div>
					        <div class="center">
					          <svg-icon icon-class="linear-play" class="svgimg" />
					          775人收看
					        </div>
					      </div>
					    </div>
					  </div>
					</div>
					
	   </el-carousel-item>
	 </el-carousel>

    <el-carousel v-show="tagactive == 2" ref="swiperll2" indicator-position="none" arrow='never' :loop='false' :autoplay = 'false' height='480px'>
       <el-carousel-item v-for="item in 3" :key="item">
         
    				<div class="cont between wrap" >
    				  <div class="cont_flwj" v-for="(item, index) in 4" :key="index">
    				    <div class="bt ellipsis">当兵有什么要求</div>
    				    <div class="des">
    				      {{
    				        `应征青年中农业户口的应具备初中毕业以上文化程度，非农业户口的应具备高中毕业以上文化程度；企业单位具有高中毕业以上文化程度...`
    				          | toEllipsisFilter(60)
    				      }}
    				    </div>
    				    <div class="wzbottom between">
    				      <div class="flex_start">
    				        <div class="ly"></div>
    				        <div>
    				          <div class="ti">xx律师</div>
    				          <div class="ad">xxXX律师事务所</div>
    				        </div>
    				      </div>
    				      <div class="time">2021-01-28</div>
    				    </div>
    				  </div>
    				</div>
    				
       </el-carousel-item>
     </el-carousel>

    <div class="dots flex center">
    	<div
    		:class="['dot',index == swiperllindex?'dot-active':'']" 
    		v-for="(item,index) in 3"
    		@click="swiperll(index)"
    		></div>
    </div>
    </div>
  </div>
</template>

<script>
import secTitle from "views/home/components/secTitle";
import quesMedia from "views/question/components/quesMedia";
export default {
  components: {
    secTitle,
    quesMedia,
  },
  data: () => ({
    tagactive: 0,
    imgsrc: require("../../../assets/question/spsf_sample.png"),
	swiperllindex:0,
  }),
  created() {
  	
  },
  methods: {
    tagcl(index) {
      this.tagactive = index;
    },
	swiperll(index){
		this.swiperllindex = index
		if(this.tagactive == 0){
			this.$refs.swiperll.setActiveItem(index)
		}else if(this.tagactive == 1){
			this.$refs.swiperll2.setActiveItem(index)
		}else if(this.tagactive == 2){
			this.$refs.swiperll2.setActiveItem(index)
		}
	}
  },
};
</script>

<style lang="scss" scope>
.qestjxflzs {
  width: 1200px;
  padding: 50px 0;
  margin: 0 auto;
  .tag {
    // border-bottom: 1px solid #e9e9e9;
    .tag_list {
      font-size: 20px;
	  margin-right: 20px;
      div {
        cursor: pointer;
        color: #333333;
        padding: 0 20px;
        margin: 15px 0;
        border-right: 1px solid #e9e9e9;
      }
      .atg_activ {
        color: #0465ea;
      }
    }
    .mo {
      cursor: pointer;
      font-size: 14px;
      color: #666666;
    }
  }
  .cont {
    .cont_i {
      margin-top: 30px;
      width: 380px;
      text-align: left;
	  background-color: #ffffff;
      &:hover {
        .desctext {
          .title3 {
            color: #0465ea;
          }
        }
      }
      .cont_imedia {
        width: 380px;
        height: 240px;
      }
      .desctext {
		  padding: 15px;
        .title3 {
          margin-top: 20px;
          font-size: 22px;
          color: #333333;
        }
        .time_num {
          margin-top: 10px;
          font-size: 14px;
          color: #999999;

          img {
            width: 14px;
            height: 14px;
            margin-right: 6px;
          }
          .svgimg {
            font-size: 14px;
            color: #a2a2a2;
            margin-right: 6px;
          }

          div {
            margin-right: 15px;
          }
        }
      }
    }

    .cont_flwj {
      margin-top: 30px;
      width: 586px;
      height: 210px;
      background: #ffffff;
      box-shadow: 0px 0px 27px 0px rgba(193, 193, 193, 0.4);
      border-radius: 8px;
      padding: 32px 28px;
      text-align: left;
      .bt {
        font-size: 20px;
        color: #333333;
      }
      .des {
        margin-top: 10px;
        font-size: 16px;
        color: #999999;
        line-height: 26px;
        padding-left: 18px;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          top: 20%;
          left: 0;
          width: 4px;
          height: 34px;
          background: #e3efff;
        }
      }
      .wzbottom {
        margin-top: 14px;
        font-size: 14px;
        color: #999;
        .ly {
          width: 44px;
          height: 44px;
          background: #0465ea;
          border-radius: 50%;
          margin-right: 14px;
        }
        .ti {
          font-size: 16px;
          color: #333333;
        }
        .ad {
          margin-top: 6px;
        }
      }
    }
  }
}

// 轮播指示点
.dots{
	margin-top: 15px;
	.dot{
		width: 12px;
		height: 12px;
		background: #ccc;
		border-radius: 50%;
		margin-right: 22px;
	}
	.dot-active{
		background: #0465EA;
	}
}
</style>